const UserActionType = {
    FETCH_ALL_USERS: "FETCH_ALL_USERS",
    FETCH_SINGLE_USER: "FETCH_SINGLE_USER",
    REMOVE_USER: "REMOVE_USER",
    UPDATE_USER: "UPDATE_USER",
    UPDATE_USER_POINTS: "UPDATE_USER_POINTS",
    GET_FRIENDS: "GET_FRIENDS",
    ADD_FRIEND: "ADD_FRIEND",
    GET_FRIEND_REQUESTS: "GET_FRIEND_REQUESTS",
    ACCEPT_REQUEST: "ACCEPT_REQUEST",
    DECLINE_REQUEST: "DECLINE_REQUEST",
    DELETE_FRIEND: "DELETE_FRIEND",
    UNLOCKED_ACHIEVEMENT: "UNLOCKED_ACHIEVEMENT",
  };

export default UserActionType;
